import React from "react";
import {
  subscribeHostSeatRequest,
  unsubscribeHostSeatRequest,
} from "modules/joinRoom/host.seat.firebase";
import logger from "logging/logger";
import { roomHasFreeAdminSeat } from "helpers/roomHelper";
import { addDialogNotification } from "modules/dialogNotification/redux/dialogNotificationSlice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { useI18n } from "i18n";
import { IRoom } from "types";
import { selectIsEventManager } from "modules/event/selectors";
import { useHostSeat } from "modules/movement";
import HostSeatRequest from "./HostSeatRequest";

const HostSeatRequestHandler = ({ room }: { room: IRoom }) => {
  const { t } = useI18n(["template"]);

  const hasEventManagerAccess = useSelector(selectIsEventManager);
  const dispatch = useAppDispatch();
  const roomId = room.id;

  const { switchToHostSeat } = useHostSeat();

  const getNotificationContent = () => <HostSeatRequest />;

  const handleHostSeatRequest = (req: { userId: string }) => {
    logger.info("[handleHostSeatRequest]", req);

    // If admin seat is free, then show a popup
    if (roomHasFreeAdminSeat(roomId)) {
      dispatch(
        addDialogNotification({
          title: t("template:take.admin.seat"),
          content: getNotificationContent(),
          onConfirm: () => {
            switchToHostSeat({ userId: req.userId });
          },
          confirmText: t("template:take.admin.seat"),
          dismissText: t("template:keep.current.seat"),
        }),
      );

      return;
    }

    logger.info(`[handleHostSeatRequest] no free admin seat ${room.code}`);
  };

  React.useEffect(() => {
    if (hasEventManagerAccess) {
      subscribeHostSeatRequest(handleHostSeatRequest, room.id);
    }

    return () => {
      if (hasEventManagerAccess) {
        unsubscribeHostSeatRequest(room.id);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleHostSeatRequest, hasEventManagerAccess, roomId]);

  return null;
};

export default React.memo(HostSeatRequestHandler);
